import React from "react";
const Identities = () => {
  return (
    <>
    <div id="main-area">
  <div id="article">
    Under Construction / Gender Spectrum Cube / Wiki
  </div>
  </div>
    </>
);
}

export default Identities;